export default __webpack_public_path__ + "static/media/mercadocarbono.aa364956.png";